import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Notifications from 'react-notification-system-redux'
import * as formatters from '../../../common/formatters'

import PermissionsCheck from '../../auth/components/PermissionsCheck'

import { PERMS } from '../permissions'
import Dropzone from "react-dropzone"
import * as driversActionCreators from "../actionCreators"
import * as selectors from "../selectors"
import { LoadingOverlay } from "../../../common/loading_overlay"
import { SelectField } from "../../../common/form";

class DriversImport extends Component {
    stepNames = {
        1: this.props.intl.formatMessage({ id: 'modules.driversImport.stepNames.1' }),
        2: this.props.intl.formatMessage({ id: 'modules.driversImport.stepNames.2' }),
        3: this.props.intl.formatMessage({ id: 'modules.driversImport.stepNames.3' })
    }

    columnTypes = {
        'firstName': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.firstName' }),
        'lastName': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.lastName' }),
        'cardNumber': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.cardNumber' }),
        'code': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.code' }),
        'phone': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.phone' }),
        'active': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.active' }),
        'locale': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.locale' }),
        'driverType': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.driverType' }),
        'dispatcher': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.dispatcher' }),
        'costCenter': this.props.intl.formatMessage({ id: 'modules.driversImport.columnTypes.costCenter' }),
    }

    state = {
        step: 1,
        importHeaders: [],
        importFileId: null,
        importFileName: null,
        importItems: [],
        importItemValues: [],
        columnTypes: {},
        defaultLocale: null,
        importAllItemsChecked: false
    }

    importProcessing = false

    onDropFiles = files => {
        files.forEach(file => {
            const reader = new FileReader()
            const fileName = file.name

            reader.onload = e => {
                const loadedFile = {
                    name: fileName,
                    base64: e.target.result,
                }
                this.props.actions.fetchDriversImportHeaders(loadedFile)
            }

            reader.readAsDataURL(file)
        })
    }

    onBackButtonClick = () => {
        this.setState({
            ...this.state,
            step: this.state.step - 1
        })
    }

    onSummaryButtonClick = () => {
        this.props.actions.fetchDriversImportItems(this.state.importFileId, this.state.columnTypes)
    }

    setColumnType = (id, value) => {
        this.setState({
            columnTypes: {
                ...this.state.columnTypes,
                [id]: value
            }
        })
    }


    onImportItemChange = (key, value) => {
        this.setState({
            importItemValues: {
                ...this.state.importItemValues,
                [key]: value
            }
        })
    }

    onImportAllItemsChange = (value) => {
        this.setState({
            importAllItemsChecked: value
        })

        var importItemValues = {};

        for (var key in this.state.importItemValues) {
            importItemValues[key] = value
        }

        this.setState({
            importItemValues: importItemValues
        })
    }

    onImportButtonClick = () => {
        this.importProcessing = true
        this.props.actions.importDrivers(this.state.importFileId, this.state.columnTypes, this.state.importItemValues)
    }

    componentWillMount() {

    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.importInProgress && !nextProps.importInProgress) {
            // Import error
            if (nextProps.importError) {
                this.props.notify({
                    title: this.props.intl.formatMessage({ id: 'alerts.titles.error' }),
                    message: nextProps.importError,
                    position: 'tc',
                }, 'error')

                this.importProcessing = false

                return false;
            }
            else if (this.state.step === 1) {
                const headers = nextProps.importHeaders.valueSeq().toArray()
                const defaultHeaders = nextProps.importDefaultHeaders.toJS()
                const columnTypes = {}

                nextProps.importHeaders.map((headerName, headerId) => {
                    if (defaultHeaders[headerName]) {
                        columnTypes[headerId] = defaultHeaders[headerName]
                    }

                    return false;
                })

                this.setState({
                    ...this.state,
                    step: 2,
                    importHeaders: headers,
                    importFileId: nextProps.importFileId,
                    importFileName: nextProps.importFileName,
                    columnTypes,
                })
            }
            else if (this.state.step >= 2) {
                if (this.importProcessing) {
                    this.props.notify({
                        title: this.props.intl.formatMessage({ id: 'alerts.titles.success' }),
                        message: this.props.intl.formatMessage({ id: 'alerts.messages.importSuccess' }),
                        position: 'tc',
                    }, 'success')

                    this.props.redirect('/drivers/')
                }

                const items = nextProps.importItems
                const itemValues = []

                items.map((item, key) => {
                    itemValues[key] = item.firstName && item.lastName ? true : false
                })
                this.setState({
                    ...this.state,
                    step: 3,
                    importItems: items,
                    importItemValues: itemValues,
                })
            }
        }
    }

    /* eslint-disable jsx-a11y/anchor-is-valid */
    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.driversImport.heading' }))

        const columnTypesOptions = Object.keys(this.columnTypes).map(id => ({
            id: id,
            name: this.columnTypes[id],
        }))

        columnTypesOptions.unshift({
            id: null,
            name: '-'
        })

        return (<PermissionsCheck has={[PERMS.CREATE]} noPermissionsPage>
                <div className={'page-inner '+(document.body.classList.contains('mobile-menu-open') ? 'sidebar-visible' : '')}>
                    <div id="main-wrapper">
                        <div className="row hp-100">
                            <div className={'col-md-12 col-xl-10 col-xl-offset-1'}>
                                <LoadingOverlay active={this.props.importInProgress}>
                                    <div className="panel panel-white">
                                        <div className="panel-body panel-padding">
                                            <h4>
                                                <FormattedMessage id="modules.driversImport.heading" /> - <FormattedMessage id="modules.driversImport.step" /> {this.state.step}/3 ({this.stepNames[this.state.step]})
                                            </h4>

                                            {this.state.step === 1 && (<div className="wp-100 pull-left clearfix">
                                                <p className="m-b-lg">
                                                    <FormattedMessage id="import.step1" />
                                                </p>
                                                <Dropzone onDrop={this.onDropFiles} multiple={false} style={{}} className="dropzone" acceptClassName="dropzone-accept">
                                                    <p className="ready">
                                                        <FormattedMessage id="fields.dropzoneReady" />
                                                    </p>
                                                    <p className="accept">
                                                        <FormattedMessage id="fields.dropzoneAccept" />
                                                    </p>
                                                </Dropzone>
                                            </div>)}

                                            {this.state.step === 2 && (<div className="wp-100 pull-left clearfix">
                                                <p className="m-b-lg">
                                                    <FormattedMessage id="import.step2" />
                                                </p>

                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        {Object.keys(this.state.importHeaders).map(headerId => {
                                                            let headerName = this.state.importHeaders[headerId]
                                                            if(!headerName){
                                                                return
                                                            }
                                                            return <div key={headerId}>
                                                                <SelectField
                                                                    id={headerId}
                                                                    label={headerName}
                                                                    readonly={() => false}
                                                                    values={columnTypesOptions}
                                                                    value={this.state.columnTypes[headerId]}
                                                                    onChange={e => {
                                                                        this.setColumnType(headerId, e.value)
                                                                    }}
                                                                />
                                                            </div>
                                                        })}
                                                    </div>
                                                </div>
                                            </div>)}

                                            {this.state.step === 3 && (<div className="wp-100 pull-left clearfix">
                                                <p className="m-b-lg">
                                                    <FormattedMessage id="import.step3" />
                                                </p>

                                                {!this.state.importItems.length && (<div className="alert alert-danger">
                                                    <p>
                                                        <FormattedMessage id="import.noItemsFound" />
                                                    </p>
                                                </div>)}

                                                {this.state.importItems.length && (<div>

                                                    <table className="table table-striped">
                                                        <thead>
                                                        <tr>
                                                            <th className="w-40 text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id={'item-all'}
                                                                    onChange={(e) => {
                                                                        this.onImportAllItemsChange(e.target.checked)
                                                                    }}
                                                                    checked={this.state.importAllItemsChecked}
                                                                />
                                                            </th>
                                                            <th className="w-160">
                                                                {this.columnTypes.lastName}
                                                            </th>
                                                            <th className="w-160">
                                                                {this.columnTypes.firstName}
                                                            </th>
                                                            <th className="w-100">
                                                                {this.columnTypes.locale}
                                                            </th>
                                                            <th className="w-120">
                                                                {this.columnTypes.driverType}
                                                            </th>
                                                            <th className="w-100">
                                                                {this.columnTypes.code}
                                                            </th>
                                                            <th className="w-180">
                                                                {this.columnTypes.cardNumber}
                                                            </th>
                                                            <th className="w-140">
                                                                {this.columnTypes.dispatcher}
                                                            </th>
                                                            <th className="w-max">
                                                                {this.columnTypes.phone}
                                                            </th>
                                                            <th className="w-100">
                                                                {this.columnTypes.costCenter}
                                                            </th>
                                                            <th className="w-70 text-center">
                                                                {this.columnTypes.active}
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.importItems.map((item, key) => {
                                                            return (<tr key={'importItem-' + key}>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={'item-' + key}
                                                                        onChange={(e) => {
                                                                            this.onImportItemChange(key, e.target.checked)
                                                                        }}
                                                                        disabled={!item.lastName && !item.firstName}
                                                                        checked={this.state.importItemValues[key]}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {item.lastName}
                                                                </td>
                                                                <td>
                                                                    {item.firstName}
                                                                </td>
                                                                <td>
                                                                    {item.locale}
                                                                </td>
                                                                <td>
                                                                    {item.driverType && (<div>
                                                                        {item.driverType} {formatters.boolFormatter(item.driverTypeId ? 1 : 0)}
                                                                    </div>)}
                                                                </td>
                                                                <td>
                                                                    {item.code}
                                                                </td>
                                                                <td>
                                                                    {item.cardNumber}
                                                                </td>
                                                                <td>
                                                                    {item.dispatcher && (<div>
                                                                        {item.dispatcher} {formatters.boolFormatter(item.dispatcherId ? 1 : 0)}
                                                                    </div>)}
                                                                </td>
                                                                <td>
                                                                    {item.phone}
                                                                </td>
                                                                <td>
                                                                    {item.costCenter && (<div>
                                                                        {item.costCenter} {formatters.boolFormatter(item.costCenterId ? 1 : 0)}
                                                                    </div>)}
                                                                </td>
                                                                <td className="text-center">
                                                                    {formatters.boolFormatter(item.active)}
                                                                </td>
                                                            </tr>)
                                                        })}
                                                        </tbody>
                                                    </table>
                                                </div>)}
                                            </div>)}

                                            <div className="pull-left wp-100 btns-form">
                                                {this.state.step > 1 && (
                                                    <button onClick={this.onBackButtonClick} className="btn btn-addon btn-default">
                                                        <i className="far fa-chevron-left" /> <FormattedMessage id="buttons.back" />
                                                    </button>)}

                                                {this.state.step === 2 && (
                                                    <button onClick={this.onSummaryButtonClick} className="btn btn-addon btn-success pull-right">
                                                        <i className="far fa-chevron-right" /> <FormattedMessage id="buttons.continue" />
                                                    </button>)}

                                                {this.state.step === 3 && (
                                                    <button onClick={this.onImportButtonClick} className="btn btn-addon btn-success pull-right">
                                                        <i className="far fa-check" /> <FormattedMessage id="buttons.import" />
                                                    </button>)}
                                            </div>
                                        </div>
                                    </div>
                                </LoadingOverlay>
                            </div>
                        </div>
                    </div>
                </div>
            </PermissionsCheck>)
    }
}

function mapStateToProps(state) {
    return {
        importInProgress: selectors.getImportInProgress(state),
        importError: selectors.getImportError(state),
        importFileId: selectors.getImportFileId(state),
        importHeaders: selectors.getImportHeaders(state),
        importDefaultHeaders: selectors.getImportDefaultHeaders(state),
        importItems: selectors.getImportItems(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators({
                ...driversActionCreators
            }, dispatch),
        },
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
        redirect: toURL => dispatch(push(toURL)),
        dispatch,
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps, ...dispatchProps, ...ownProps
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps, mergeProps)(DriversImport))
